import React from 'react';
import axios from "axios";
import AuthService from './AuthService';

const API_URL = `${process.env.REACT_APP_API_ENDPOINT}/api/`;

const authHeader = () => {
    // const access_token = JSON.parse(localStorage.getItem('access_token'));
    const access_token = localStorage.getItem('access_token');
    if (access_token) {
        return { Authorization: `Bearer ${access_token}` }
    } else {
        return {};
    }
}

const getActivities = async (filter = [], ignorePage = 0) => {

    var stringQ = 'activities';

    if (filter['limit']) {
        stringQ += '?limit=' + filter['limit']
    } else {
        stringQ += '?limit=50';
    }

    if (filter['domain']) {
        stringQ += '&domain=' + filter['domain']
    }

    if (filter['page']) {
        stringQ += '&page=' + filter['page']
    }

    if (filter['sort']) {
        stringQ += '&sort=' + filter['sort']
    } else {
        stringQ += '&sort=createdAt';
    }

    if (filter['order']) {
        stringQ += '&order=' + filter['order']
    } else {
        stringQ += '&order=desc';
    }

    if (filter['roomId'] && filter['roomId'] === 'no-show') {
        stringQ += '&roomId='
    } else if (filter['roomId']) {
        stringQ += '&roomId=' + filter['roomId']
    } else if (AuthService.getCurrentRoomId()) {
        stringQ += '&roomId=' + AuthService.getCurrentRoomId();
    }


    if (filter['startDate']) {
        stringQ += '&startDate=' + filter['startDate']
    }

    if (filter['endDate']) {
        stringQ += '&endDate=' + filter['endDate']
    }

    if (filter['status']) {
        stringQ += '&status=' + filter['status']
    }

    if (filter['studentId']) {
        stringQ += '&studentId=' + filter['studentId']
    }

    if (filter['year']) {
        stringQ += '&year=' + filter['year']
    }



    if (filter['term']) {
        stringQ += '&term=' + filter['term']
    }



    return axios.get(API_URL + stringQ);
};

const getStudentInRoom = async (roomId) => {
    if (roomId) {
        return axios.get(API_URL + "rooms/" + roomId);
    }
    return [];
};

const getCognitorUserProfile = async (username) => {
    if (username) {
        return axios.get(API_URL + "cognito/users/by-username/" + username);
    }
    return [];
};

const postActivityAnswer = async (id, answer = []) => {
    if (id) {
        return axios.post(API_URL + `activities/${id}/answers`, answer, { headers: authHeader() });
    }
    return [];
};

const getActivityAnswer = async (activityId, questionId) => {
    if (activityId && questionId) {
        const answer1 = axios.get(API_URL + `sse/activities/603bc47ed194ae309f3cd0b5/questions/603bc03ad194ae309f3cd0ae/answers-percent`);
        const answer2 = axios.get(API_URL + `sse/activities/603bc47ed194ae309f3cd0b5/questions/603bc03ad194ae309f3cd0af/answers`);
        const answer3 = axios.get(API_URL + `sse/activities/603bc47ed194ae309f3cd0b5/questions/603bc03ad194ae309f3cd0b0/answers`);
        return [{
            'answer1': answer1.data,
            'answer2': answer2.data,
            'answer3': answer3.data
        }];
    }
    return [];
};

const convertToAPIURL = (link) => {
    if (link) {
        return API_URL + link
    }
    return API_URL
};

const getActivityDetail = async (activityId) => {
    console.log('getActivityDetail')
    console.log(activityId)
    const detail = axios.get(API_URL + `activities/${activityId}`);

    return detail;
};
const getAnswersPercent = async (activityId, questionId) => {

    const answersPercent = axios.get(API_URL + `activities/${activityId}/questions/${questionId}/answers-percent`);

    return answersPercent;
};

const getAnswers = async (activityId, questionId) => {
    const answers = axios.get(API_URL + `activities/${activityId}/questions/${questionId}/answers`);
    return answers;
};

const getAnswersByStudentId = async (activityId, questionId, studentId) => {
    const answers = await axios.get(API_URL + `activities/${activityId}/questions/${questionId}/answers`);

    var temp = null;
    for (const [index, value] of answers.data.data.entries()) {
        if (value.userId === studentId) {
            temp = value;
        }

    }
    return temp;
};

const startActivity = async (topicId) => {
    if (topicId) {
        const data = { topicId: topicId }
        return axios.post(API_URL + `activities`, data, { headers: authHeader() });
    }
    return [];
};

const endActivity = async (activityId) => {
    if (activityId) {
        return axios.post(API_URL + `activities/${activityId}/end`, {}, { headers: authHeader() });
    }
    return [];
};

// const getActivitiesByStudentId = async (studentId, inputs = null) => {
//     const data = axios.get(API_URL + `activities?status=FINISHED&studentId=${studentId}`);
//     return data;
// };

const getStudentsAndActivitiesCountByRoomId = async (roomId, inputs = null) => {
    const data = axios.get(API_URL + `rooms/${roomId}/student-total-activity`);
    return data;
}


const getRoomList = async (user) => {

    // const data = axios.get(API_URL + `rooms?domain=${user.domain}&term=${user.term}`);
    // return data;

    var stringQ = 'rooms?domain=' + user.domain;

    if (user.term) {
        stringQ += '&term=' + user.term
    }

    if (user.year) {
        stringQ += '&year=' + user.year
    }
    return axios.get(API_URL + stringQ);


}

const getCategory = async () => {
    const data = axios.get(API_URL + `categories`);
    return data;
}

const getTopics = async (filter) => {
    // console.log('------------------------')
    // console.log(filter);
    // console.log('------------------------')

    if (!filter['random']) {
        var stringQ = 'topics';

        if (filter['limit']) {
            stringQ += '?limit=' + filter['limit']
        } else {
            stringQ += '?limit=50';
        }

        if (filter['page']) {
            stringQ += '&page=' + filter['page']
        }

        if (filter['sort']) {
            stringQ += '&sort=' + filter['sort']
        } else {
            stringQ += '&sort=createdAt';
        }

        if (filter['order']) {
            stringQ += '&order=' + filter['order']
        } else {
            stringQ += '&order=desc';
        }

        if (filter['category']) {
            stringQ += '&category=' + filter['category']
        }

    } else {
        var stringQ = 'topics/random?limit=50';
    }

    if (filter['roomId']) {
        stringQ += '&roomId=' + filter['roomId']
    }

    return axios.get(API_URL + stringQ, { headers: authHeader() });
}

const getTopicsRandom = async () => {
    const data = axios.get(API_URL + `topics/random?limit=50`);
    return data;
}

const getAttendersCount = async (activityId) => {
    const data = axios.get(API_URL + `activities/${activityId}/attenders-count`);
    return data;
}

const postStudentJoinActivity = async (activityId) => {
    if (activityId) {
        return axios.post(API_URL + `activities/${activityId}/join`, {}, { headers: authHeader() });
    }
    return [];
};

const postTeacherAnswer = async (activityId, answer = []) => {
    if (activityId) {
        // return axios.post(API_URL + `activities/${activityId}/comment`, answer, { headers: authHeader() });
        return axios.post(API_URL + `activities/${activityId}/comment`, answer, { headers: authHeader() });
    }
    return [];
}

const getUserAndDomain = (userId) => {
    // const data = axios.get(API_URL + `users/${userId}`);       
    const data = axios.get(API_URL + `cognito/users/${userId}`);
    return data;
};


const getEvaluationForms = async (formName) => {
    const data = axios.get(API_URL + `evaluation-forms/${formName}`);
    return data;
}

const getFriendShipList = async (userId, filter = []) => {

    var stringQ = `friendship?userId=${userId}`;
    if (filter['roomId']) {
        stringQ += '&roomId=' + filter['roomId'];
    } else {
        stringQ += '&roomId=' + AuthService.getComputeRoomId();
    }


    if (filter['year']) {
        stringQ += '&year=' + filter['year']
    }

    if (filter['domain']) {
        stringQ += '&domain=' + filter['domain']
    }

    if (filter['term']) {
        stringQ += '&term=' + filter['term']
    }

    const data = axios.get(API_URL + stringQ);

    const result = (await data).data.data

    for (let i = 0; i < result.length; i++) {
        const ownerUserId = result[i].user.id
        const target = result[i].targets
        const other = result[i].others.filter(function (val) { return val.user.id === ownerUserId })[0];
        if (target) {
            for (let ii = 0; ii < target.length; ii++) {
                if (target[ii].user.id === ownerUserId) {
                    target[ii] = other;
                }
            }
        }
    }

    return data;

}

const getStrengths = async (userId) => {
    const data = axios.get(API_URL + 'strengths');
    return data;
}


const getFriendshipReportList = async (roomId) => {
    const data = axios.get(API_URL + `friendship?roomId=${roomId}&limit=300`);
    const result = (await data).data.data

    for (let i = 0; i < result.length; i++) {
        const ownerUserId = result[i].user.id
        const target = result[i].targets
        const other = result[i].others.filter(function (val) { return val.user.id === ownerUserId })[0];
        if (target) {
            for (let ii = 0; ii < target.length; ii++) {
                if (target[ii].user.id === ownerUserId) {
                    target[ii] = other;
                }
            }
        }
    }

    return data;
}


const getFriendshipReportList2 = async (roomId) => {
    if (roomId != 0) {
        const data = axios.get(API_URL + `friendship?roomId=${roomId}`);
        const result = (await data).data.data

        for (let i = 0; i < result.length; i++) {
            const ownerUserId = result[i].user.id
            const target = result[i].targets
            const other = result[i].others.filter(function (val) { return val.user.id === ownerUserId })[0];
            if (target) {
                for (let ii = 0; ii < target.length; ii++) {
                    if (target[ii].user.id === ownerUserId) {
                        target[ii] = other;
                    }
                }
            }
        }

        return data;

    } else {
        return null;
    }

}

const postPersonEvaluationForms = async (answer) => {
    if (answer) {
        return axios.post(API_URL + `friendship/answers`, answer, { headers: authHeader() });
    }
    return [];
}

const allActivitiesInSchool = async (filter) => {

    // var stringQ = 'activities/top';

    // if (filter['year']) {
    //     stringQ += '?year=' + filter['year']
    // } 

    // if (filter['domain']) {
    //     stringQ += '&domain=' + filter['domain']
    // }

    // if (filter['term']) {
    //     stringQ += '&term=' + filter['term']
    // } 


    // return axios.get(API_URL + stringQ);    
}

const activitiesTotal = async (filter = []) => {

    var stringQ = 'activities/total';

    if (filter['roomId']) {
        stringQ += '?roomId=' + filter['roomId'];
    }
    else {
        stringQ += '?roomId=' + AuthService.getCurrentRoomId();
    }

    if (filter['year']) {
        stringQ += '&year=' + filter['year']

    }

    if (filter['domain']) {
        stringQ += '&domain=' + filter['domain']
    }

    if (filter['term']) {
        stringQ += '&term=' + filter['term']
        // } else {
        //     stringQ += `&term=${AuthService.getUserCurrentTerm()}`
    }

    return axios.get(API_URL + stringQ);
}

const getUserById = async (id) => {
    // return axios.get(API_URL + 'users/' + id);   
    return axios.get(API_URL + 'cognito/users/' + id);
}

const getRoomDetail = async (id) => {
    return axios.get(API_URL + 'rooms/' + id);
}


const activitiesGradeYear = async (filter) => {
    var stringQ = 'activities/grade-year';

    if (filter['domain']) {
        stringQ += '?domain=' + filter['domain'];
    }

    if (filter['year']) {
        stringQ += '&year=' + filter['year']

    }

    if (filter['term']) {
        stringQ += '&term=' + filter['term']
    }

    return axios.get(API_URL + stringQ);
}

const topStrength = async (filter) => {
    var stringQ = 'friendship/top-strength';

    if (filter['domain']) {
        stringQ += '?domain=' + filter['domain'];
    }

    if (filter['year']) {
        stringQ += '&year=' + filter['year']

    }

    if (filter['term']) {
        stringQ += '&term=' + filter['term']
    }

    if (filter['role']) {
        stringQ += '&role=' + filter['role']
    }

    if (filter['roomId']) {
        stringQ += '&roomId=' + filter['roomId']
    }



    return axios.get(API_URL + stringQ);
}

const summaryStrength = async (filter) => {
    var stringQ = 'friendship/strength-summary';

    if (filter['domain']) {
        stringQ += '?domain=' + filter['domain'];
    }

    if (filter['year']) {
        stringQ += '&year=' + filter['year']

    }

    if (filter['term']) {
        stringQ += '&term=' + filter['term']
    }

    if (filter['roomId']) {
        stringQ += '&roomId=' + filter['roomId']
    }

    const response = await axios.get(API_URL + stringQ);
    const raw = (response.data && response.data.data) || [];

    // กรุ๊ปครู: STUDENT_TO_TEACHER (นักเรียนประเมินครู), SELF_TEACHER (ครูประเมินตัวเอง)
    // กรุ๊ปนักเรียน: TEACHER_TO_STUDENT, STUDENT_TO_STUDENT, SELF_STUDENT
    const TEACHER_TYPES = ['STUDENT_TO_TEACHER', 'SELF_TEACHER'];
    const STUDENT_TYPES = ['TEACHER_TO_STUDENT', 'STUDENT_TO_STUDENT', 'SELF_STUDENT'];

    // รวม total ตามชื่อ strength แล้วหา 5 อันดับแรก
    const summarize = (types) => {
        const merged = raw
            .filter(d => types.includes(d.evaluationType))
            .reduce((acc, d) => {
                acc[d.name] = (acc[d.name] || 0) + d.total;
                return acc;
            }, {});

        const top5 = Object.entries(merged)
            .map(([name, total]) => ({ name, total }))
            .sort((a, b) => b.total - a.total)
            .slice(0, 5);

        const sumTop5 = top5.reduce((s, d) => s + d.total, 0);

        return { top5, sumTop5 };
    };

    const teacher = summarize(TEACHER_TYPES);
    const student = summarize(STUDENT_TYPES);

    return {
        teacher: teacher.top5,
        teacherSumTop5: teacher.sumTop5,
        student: student.top5,
        studentSumTop5: student.sumTop5,
    };
}

const activitiesGradeYearAll = async (filter) => {
    var stringQ = 'reports/total-activity-by-grade-year';
    if (filter['domain']) {
        stringQ += '?domain=' + filter['domain'];
    }

    if (filter['year']) {
        stringQ += '&year=' + filter['year']

    }

    if (filter['grade']) {
        stringQ += '&grade=' + filter['grade']
    }

    if (filter['term']) {
        stringQ += '&term=' + filter['term']
    }
    return axios.get(API_URL + stringQ);
}

const distinctYearTerm = async (filter) => {
    var stringQ = 'rooms/distinct-year-term';
    return axios.get(API_URL + stringQ);
}


const getRiasecQuestion = async (filter) => {

    var grade = 'SECONDARY_SCHOOL';
    var year = '1';

    if (filter['grade']) {
        var grade = filter['grade'];
    }

    if (filter['gradeYear']) {
        var gradeYear = filter['gradeYear'];
    }

    if (filter['targetAssessor']) {
        var targetAssessor = filter['targetAssessor'];
    }

    var stringQ = 'riasec-forms?targetGrade=' + grade + '&targetGradeYear=' + gradeYear + '&targetAssessor=' + targetAssessor.toUpperCase();
    return axios.get(API_URL + stringQ);
}

const postRiasecAnswer = async (id, answer = []) => {
    if (id) {

        return axios.post(API_URL + `riasec-assessments`, answer, { headers: authHeader() });
    }
    return [];
};

const getRiasecStudentInRoom = async (roomId) => {

    if (roomId) {
        var stringQ = 'rooms/' + roomId + '/riasec-status';
        return axios.get(API_URL + stringQ);
    }
    return [];
}

const getRiasecResult = async (roomId, studentId, assessor) => {

    if (roomId && studentId && assessor) {
        var stringQ = `riasec-assessments?roomId=${roomId}&studentId=${studentId}&assessor=${assessor}`;
        return axios.get(API_URL + stringQ);
    }
    return null;
}

const getRiasecReport = async (roomId) => {

    if (roomId) {
        var stringQ = `riasec-assessments/dashboard?&roomId=${roomId}`;
        return axios.get(API_URL + stringQ);
    }
    return null;
}

const getRoomByTeamYearUser = async (filter) => {
    var stringQ = 'rooms';

    if (filter['domain']) {
        stringQ += '?domain=' + filter['domain'];
    }

    if (filter['year']) {
        stringQ += '&year=' + filter['year']

    }

    if (filter['term']) {
        stringQ += '&term=' + filter['term']
    }

    if (filter['studentId']) {
        stringQ += '&studentId=' + filter['studentId']
    }

    if (filter['teacherId']) {
        stringQ += '&teacherId=' + filter['teacherId']
    }

    if (filter['limit']) {
        stringQ += '&limit=' + filter['limit']
    }


    return axios.get(API_URL + stringQ);
}

const getCognitorUserByUser = async (studentId) => {
    if (studentId) {
        var stringQ = `cognito/users/${studentId}`;
        return axios.get(API_URL + stringQ);
    }
    return null;
}

const getDomain = async (domainId) => {
    if (domainId) {
        var stringQ = `domains/${domainId}`;
        return axios.get(API_URL + stringQ);
    }
    return null;
}


const getLogoUrl = () => {
    if (localStorage.getItem("logoUrl")) {

        return localStorage.getItem("logoUrl");
    }
    return null
}

const getFriendshipGameReport = async (filter) => {
    if (filter['domain'] && filter['year'] && filter['term']) {
        let stringQ = 'friendship-game';
        if (filter['domain']) {
            stringQ += '?domain=' + filter['domain'];
        }
        if (filter['year']) {
            stringQ += '&year=' + filter['year']
        }
        if (filter['term']) {
            stringQ += '&term=' + filter['term']
        }
        if (filter['grade']) {
            stringQ += '&grade=' + filter['grade']
        }
        return axios.get(API_URL + stringQ);
    }
    return null;
}


export default {
    getActivities, getStudentInRoom, postActivityAnswer, getActivityAnswer,
    convertToAPIURL, getActivityDetail, getAnswersPercent, getAnswers,
    getStudentsAndActivitiesCountByRoomId, getAnswersByStudentId, getRoomList,
    startActivity, endActivity, getCategory, getTopics, getTopicsRandom, postTeacherAnswer,
    getAttendersCount, postStudentJoinActivity, getUserAndDomain, getEvaluationForms,
    getFriendShipList, getStrengths, getFriendshipReportList, postPersonEvaluationForms,
    allActivitiesInSchool, activitiesTotal, getUserById, getRoomDetail, activitiesGradeYear, topStrength, summaryStrength, activitiesGradeYearAll,
    distinctYearTerm, getFriendshipReportList2, getCognitorUserProfile, getRiasecQuestion, postRiasecAnswer, getRiasecStudentInRoom,
    getRiasecReport, getRiasecResult, getRoomByTeamYearUser,
    getCognitorUserByUser, getDomain, getLogoUrl, getFriendshipGameReport

};
